import type { Component, Entity2D } from '../../odie';

import type { CandleBlockProps, CountBlockOptionDef } from '../defs/block';
import { CandleBlockView } from '../views/blocks/CandleBlockView';

// types
//-----------------------------------------------------------------------------
export type CandleBlockComponentOptions = {
  props: CandleBlockProps;
  option?: number;
};

/*
    candle block component
*/
export class CandleBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockCandle';

  // fields
  //-------------------------------------------------------------------------
  private props!: CandleBlockProps;
  // injected
  public entity!: Entity2D;
  // scene
  public view!: CandleBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: CandleBlockComponentOptions): void {
    // get option def
    const optionDef = options.props.options?.[
      options.option || 0
    ] as CountBlockOptionDef; // create candle block view

    this.props = options.props;

    this.view = new CandleBlockView(options.props);

    // set initial count
    this.view.count = optionDef.count;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  // api
  //-------------------------------------------------------------------------
  public isEmpty(): boolean {
    return this.view.count === 0;
  }

  public poke() {
    --this.view.count;
  }

  public getGameplayState(): number {
    const options = this.props.options as CountBlockOptionDef[];
    return options.findIndex((opt) => {
      return opt.count === this.view.count;
    });
  }
}
